<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="#FEF3C7" />
    <path
      d="M20 21.12V17.38"
      stroke="#D97706"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.999 24.125C19.861 24.125 19.749 24.237 19.75 24.375C19.75 24.513 19.862 24.625 20 24.625C20.138 24.625 20.25 24.513 20.25 24.375C20.25 24.237 20.138 24.125 19.999 24.125"
      stroke="#D97706"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.0288 12.1389L29.6878 25.5429C30.5778 27.1009 29.4528 29.0399 27.6588 29.0399H12.3408C10.5458 29.0399 9.42076 27.1009 10.3118 25.5429L17.9708 12.1389C18.8678 10.5679 21.1318 10.5679 22.0288 12.1389Z"
      stroke="#D97706"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
